import { IconButton, Tooltip } from "@mui/material";
import { defineMessages, useIntl } from "react-intl";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import { CLIENT_ID, MANUALS_KEY } from "../constants";

const messages = defineMessages({
  btnTitle: {
    id: "getManual.btnTitle",
    defaultMessage: "Open User Manual",
  },
});

export const GetManual = () => {
  const { formatMessage: t, locale } = useIntl();
  const link = `/ws/manuals/app/${CLIENT_ID}/${MANUALS_KEY}?locale=${locale}`;
  return (
    <Tooltip title={t(messages.btnTitle)}>
      <IconButton
        size="large"
        color="secondary"
        component="a"
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t(messages.btnTitle)}
      >
        <MenuBookIcon />
      </IconButton>
    </Tooltip>
  );
};
